export default __webpack_public_path__ + "static/media/r6.43428929.png";